/**
 * FolderPathBar · Composer 输入框内顶部「当前文件夹」上下文条
 *
 * 进入文件夹详情页时，在输入框内部顶部显示一条「在「路径」下创建：」上下文，
 * 提示用户 AI 新建的分类会落在当前文件夹下；右侧 X 可移除该上下文。
 *
 * 数据来源：redux 的 composerFolderContext（详情页 Detail/index.tsx 写入、离开清除）。
 *  · 列表页该值为 null → 不渲染
 *  · 详情页刚进、path 还没就绪（getFolderInfo 未回）→ path 为占位「/」→ 不渲染
 *  · 点 X → 清空 redux 上下文 → 本条隐藏；切到别的文件夹会重新带出当前文件夹上下文
 *
 * 展示规则（与产品确认）：
 *  · 文案「在「<路径>」下创建：」· 路径不含根「照片分类」（path 本身就不含根）
 *  · 单层文件夹时路径只有一段，形如「在「市场部」下创建：」
 *  · 整条单行，空间不足时路径省略号截断
 */

import React, { useCallback } from 'react'
import { CloseOutlined } from '@ant-design/icons'
import { useAppDispatch, useAppSelector } from '../../../../../../app/hooks'
import {
  selectComposerFolderContext,
  setComposerFolderContext
} from '../../../../../../slices/aiClassify'
import styles from './Composer.module.scss'

const FolderPathBar: React.FC = () => {
  const dispatch = useAppDispatch()
  const ctx = useAppSelector(selectComposerFolderContext)
  const path = ctx?.path ?? ''

  const handleRemove = useCallback(() => {
    dispatch(setComposerFolderContext(null))
  }, [dispatch])

  // 无上下文（列表页）或 path 未就绪（占位「/」/ 空）时不展示
  if (!path || path === '/') return null

  // "A/B/当前" → "A / B / 当前"（展示更易读）
  const display = path.split('/').filter(Boolean).join(' / ')
  if (!display) return null

  return (
    <div className={styles.folderContextRow}>
      <span className={styles.folderContextText} title={path}>
        在「{display}」下创建：
      </span>
      <button
        type="button"
        className={styles.folderContextRemove}
        onClick={handleRemove}
        aria-label="移除当前文件夹上下文"
      >
        <CloseOutlined />
      </button>
    </div>
  )
}

export default FolderPathBar
